import { useState } from 'react';
import TranslationPageLayout from '../../Components/shared/TranslationPageLayout.js';
import CommonImage from '../../Components/shared/ImageComponent';
// import Footer from '../../Components/shared/Footer';
import { medicalDocumentTranslationData } from '../../Components/shared/faqList';
import FAQ from '../../Components/shared/FAQ';
// import Navbar from '../../Components/shared/Header';
import { IMAGES } from './imagesImports.js';
import HorizontleButtons from '../../Components/shared/HorizontleButtons.js';
import { useHorizontalScroll } from "../../Hooks/useHorizontalScroll.js";
import {
    section3Images,
    section5Images,
    section5V2Images,
    section5V3Images,
    section6Images,
    section6V2Images
} from "./imagesItem.js"
import "./index.css"
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount';
import { useLocation } from 'react-router-dom';
import Navbar from '../HomePage/header.js';
import Footer from '../HomePage/footer.js';

const MedicalDocumentTranslationPage = ({ windowSize }) => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);

    const {
        scrollRef: section5MedicalRef,
        scrollLeft: section5Left,
        scrollRight: section5Right,
    } = useHorizontalScroll(300);

    const {
        scrollRef: section5V1MedicalRef,
        scrollLeft: section5V1Left,
        scrollRight: section5V1Right,
    } = useHorizontalScroll(300);

    const {
        scrollRef: section5V2MedicalRef,
        scrollLeft: section5V2Left,
        scrollRight: section5V2Right,
    } = useHorizontalScroll(300);

    const handleLoginOpen = (newState) => {
        setIsModalOpen(newState);
    };

    const handleCreateAccountOpen = (newState) => {
        setIsCreateAccountOpen(newState);
    };

    return (
        <TranslationPageLayout>

            <SignInForm
                open={isModalOpen}
                isLoginFormOpen={handleLoginOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
            />
            <CreateAccount
                open={isCreateAccountOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
                isLoginFormOpen={handleLoginOpen}
            />
            {/* Medical Hero Section */}
            <div role='Medical Hero Section' className='w-full'>
                <div className='medical-medicalHeroSection'>
                    <Navbar
                        windowSize={windowSize}
                        isLoginFormOpen={handleLoginOpen}
                    />
                    <div role='content-section' className='medical-medicalHeroSectionContent'>
                        <div className='medical-contentTitle'>
                            <div className='medical-contentTitleLarge'><span className='medical-title-orange'>Medical</span> Document Translation Services by <span className='medical-title-green'>eVerbary</span> </div>
                            <div className='medical-contentTitleSmall'>At eVerbary, we specialize in medical document translation services that support healthcare providers, patients, and organizations worldwide. With expert translators who understand the medical field, we deliver accurate medical translation solutions that maintain the integrity of each medical document we translate.</div>
                        </div>
                        <div className='medical-contentSection2 w-full'>
                            <p className='medical-contentSection2Text'>Translation is essential when patient care, legal compliance, and safety are on the line. Whether you need a medical translation service for hospital records, clinical trials, or insurance documentation, eVerbary provides certified medical translations with precision.</p>
                            <img src={IMAGES?.HEROIMG} alt='section2-image' />
                        </div>
                    </div>
                </div>
            </div>

            {/* What Is Medical Document Translation? */}
            <div className='medical-section2 '>
                <div role='section2-header' className='medical-section2Header'>
                    <p className='medical-section2HeaderHeading'>What Is Medical Document Translation?</p>
                    <p className='medical-section2HeaderText'>Medical document translation refers to the process of converting medical documents from one language to another. This includes translating medical records, test results, clinical notes, consent forms, prescriptions, medical history, and device manuals. The translation must be word-for-word, accurate, and medically sound.</p>
                </div>
                <div className='medical-section2BottomCard border'>
                    <img src={IMAGES?.SECTION2IMG} alt='section-2 image' />
                    <p className='medical-section2BottomCardText'>A poorly translated medical document can result in misdiagnosis, delayed treatment, or denial of insurance claims. That’s why we only use professional translators with experience in the medical industry.</p>
                </div>
            </div>

            {/* Types of Medical Documents We Translate */}
            <div className="medical-section11">
                <div className="medical-section11Content">
                    <div className="medical-section11ContentHeading">Types of Medical Documents We Translate</div>
                    <div className="medical-section11ContentText">Our translation services include a wide range of medical records and files. The most common types of medical documents we translate include:</div>
                    <div className="medical-section11ContentCard">If you need record translation for any of the above, our translation process is simple, and we ensure every translation is accurate and complete.</div>
                </div>
                <div className='medical-section11Img'>
                    <img src={IMAGES.SECTION3IMG} alt='section3-image' />
                </div>
            </div>

            {/* Why Medical Translation Services Matter */}
            <div className='w-full bg-[#FFF] rounded-4xl'>
                <div className='medical-section5 max-w-[1280px] mx-auto'>
                    <div role='section5-header' className='medical-section5Header'>
                        <div className='medical-section5HeaderHeading'>Why Medical Translation Services Matter</div>
                        <div className='medical-section5HeaderText'>Medical translation is essential in the global healthcare system</div>
                    </div>
                    <div ref={section5MedicalRef} role="section5-Images" className="medical-section5Images scrollbar-hide">
                        {section5Images?.map((item, idx) => (
                            <div key={idx} className="medical-section5Image medical-section5ImageV1">
                                <CommonImage src={item?.src} alt={item?.alt} width={43} height={43} />
                                <div className="medical-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section5Left}
                        scrollRight={section5Right}
                        type='blue'
                    />
                    <span role='section5-bottom-text' className='medical-section5HBottomText' style={{paddingLeft:'0px'}}>Our certified medical translation services ensure sensitive medical information is conveyed clearly. Each medical translation project includes review steps that verify the accuracy of the translation.</span>
                </div>
            </div>

            {/* The Medical Translation Process */}
            <div className='w-full'>
                <div className='medical-section3'>
                    <div role='section3-header' className='medical-section3Header'>
                        <span className='medical-section3HeaderHeading'>The Medical Translation Process</span>
                        <span className='medical-section3HeaderText'>The translation process at eVerbary follows strict quality control procedures: </span>
                    </div>
                    <div role='section3-Images-and-text' className='medical-section3ImagesAndText'>
                        <div role="section3-Images" className="medical-section3Images">
                            {section3Images.map((item, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        maxWidth: windowSize.width < 640 ? '100%' : '203px',
                                        minHeight: windowSize.width < 640 ? '246px' : '372px',
                                        background : `${item?.backgroundColor}`
                                    }}
                                    className='medical-section3ImageItem relative'
                                >
                                    <img className='rounded-4xl sm:w-auto w-[200px]' src={item?.src} />
                                    <div className='flex flex-col pr-[15px] self-start absolute bottom-6'>
                                        <span className='imm-sec5-heading'>{item?.heading}</span>
                                        <span className='imm-sec5-desc'>{item?.description}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <span role='section3-Images-text' className='medical-section3ImagesText'>We complete a medical translation project with attention to detail, from the first upload to final delivery.</span>
                    </div>
                </div>
            </div>

            {/* What Sets Our Translation Services Apart */}
            <div className='medical-section6'>
                <div className='medical-section6Container'>
                    <div className='medical-section6Header'> What Sets <br /> Our Translation Services Apart </div>
                    <div className="medical-section6Images">
                        {section6Images.map((item, idx) => (
                            <div key={idx} className="medical-section6Image">
                                <CommonImage src={item?.src} alt={item?.alt} width={60} height={60} />
                                <div className="medical-imageBottomText medical-imageBottomTextWhite">
                                    {item?.text}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Certified Medical Translation You Can Rely On */}
            <div className='w-full'>
                <div className='medical-section5 max-w-[1280px]'>
                    <div role='section5-header' className='medical-section5Header'>
                        <div className='medical-section5HeaderHeading'>Certified Medical Translation You Can Rely On</div>
                        <div className='medical-section5HeaderText'>When your documents need to be official, our certified medical translation services meet compliance standards. We include a certificate of translation accuracy and provide translations that are accepted by:</div>
                    </div>
                    <div ref={section5V1MedicalRef} role='section5-Images' className='medical-section5Images scrollbar-hide'>
                        {section5V3Images?.map((item, idx) => (
                            <div key={idx} className='medical-section5Image medical-section5ImageV2'>
                                <CommonImage src={item?.src} alt={item?.alt} width={43} height={43} />
                                <div className='medical-imageBottomText'>{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section5V1Left}
                        scrollRight={section5V1Right}
                        type=''
                    />

                    <span role='section5-bottom-text' className='medical-section5HBottomText' style={{paddingLeft:'0px'}}>Certified translations include your translated documents along with a signed statement confirming the translation is accurate and complete.</span>
                </div>
            </div>

            {/* Expert Medical Translators With Real-World Experience */}
            <div className='medical-section8-container'>
                <div className='medical-section8'>
                    <div className='medical-section8Content'>
                        <span className='medical-section8ContentHeading'>Expert Medical Translators With Real-World Experience</span>
                        <span className='medical-section8ContentCenterText'>Every translator on our team has proven expertise in medical terminology. We work with translators who understand both source and target languages, as well as the requirements of the medical industry.</span>
                        <span className='medical-section8ContentBottomText'>From translating medical research studies to medical records translation for immigration or insurance purposes, we provide reliable medical translations that serve your goals.</span>
                    </div>
                    <div className='medical-section8Img '>
                        <img src={IMAGES.SECTION8IMG} alt='section8-image' />
                    </div>
                </div>
            </div>

            {/* Our Translation Services Include: */}
            <div className='medical-section5'>
                <div role='section5-header' className='medical-section5Header '>
                    <div className='medical-section5HeaderHeading'>Our Translation Services Include:</div>
                    <div className='medical-section5HeaderText'>We specialize in USCIS-certified translations. USCIS requires that the translator certify they are competent to translate the document and that the translation is complete and accurate. We follow USCIS standards for:</div>
                </div>
                <div ref={section5V2MedicalRef} role="section5-Images" className="medical-section5V2Images scrollbar-hide">
                    {section5V2Images?.map((item, idx) => (
                        <div key={idx} className="medical-section5Image medical-section5ImageV2 medical-section5ImageV3">
                            <CommonImage src={item?.src} alt={item?.alt} width={32} height={32} />
                            <div className="medical-imageBottomText">{item?.text}</div>
                        </div>
                    ))}
                </div>
                <HorizontleButtons
                    scrollLeft={section5V2Left}
                    scrollRight={section5V2Right}
                    type=''
                />
                <span role='section5-bottom-text' className='medical-section5HBottomText' style={{paddingLeft:'40px'}}>Each service is tailored to the specific needs of the medical field. We ensure every translation is done with precision, care, and adherence to the highest standards.</span>
            </div>

            {/* How Much Do Medical Translation Services Cost? */}
            <div className='rounded-4xl bg-[#F46350] w-full'>
                <div className='medical-section7N relative'>
                    <div className="medical-section7Containers">
                        <p className="medical-section7ContainerHeading">How Much Do Medical Translation Services Cost?</p>
                        <p className="medical-section7ContainerCenterText">Translation services cost $24.95 per page. Documents with dense medical terminology may require more time.</p>
                        <p className="medical-section7ContainerBottomText">We can also provide a clear quote based on your needs. No hidden charges. Just effective translation from a trusted partner.</p>
                    </div>
                    <div className="medical-section7ImageWrapper">
                        <img src={IMAGES.SECTION7IMG} alt="section7-image" width={300} height={300} />
                    </div>
                </div>
            </div>

            {/* Why USCIS Translation Services from eVerbary Stand Out */}
            <div className='medical-section6V2'>
                <div className='medical-section6Container'>
                    <div className='medical-section6V2Header'>
                        <div className='medical-section6V2HeaderHeading'>Why USCIS Translation Services from eVerbary Stand Out</div>
                        <div className='medical-section6V2HeaderText'>eVerbary is a professional translation agency trusted to deliver certified translation services for USCIS. We support thousands of immigration applicants each year with translation accuracy that meets every regulation.Why our clients trust us:</div>
                    </div>
                    <div className="medical-section6V2Images">
                        {section6V2Images?.map((item, idx) => (
                            <div key={idx} className="medical-section6V2Image">
                                <CommonImage src={item?.src} alt={item?.alt} width={60} height={60} />
                                <div className="medical-imageBottomText medical-imageBottomTextWhite">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <div className='medical-section6BottomText'>You can trust eVerbary to provide accurate medical translation that meets legal and professional standards.</div>
                </div>
            </div>

            {/* FAQ */}
            <FAQ id='faqs-legal' faqData={medicalDocumentTranslationData} />

            {/* Get Started With eVerbary */}
            <div className='medical-section10'>
                <div className='medical-section10Heading'>Get Started With eVerbary</div>
                <div className='medical-section10CenterText'>If you need professional services in medical document translation, eVerbary is ready to help. We bring expertise in medical translation and a team of professional translators trained to deliver results.</div>
                <div className='medical-section10BottomText'>We understand the sensitive medical information you trust us with. That’s why we guarantee confidentiality, translation quality, and delivery you can count on. Upload your medical records, receive certified translation, and stay compliant with industry standards. Work with a medical translation company that understands your world. Choose eVerbary.</div>
            </div>

            {/* Footer */}
            <Footer windowSize={windowSize} />

        </TranslationPageLayout>
    )
}

export default MedicalDocumentTranslationPage